export default {
  nome: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  tipo: {
    value: null,
    options: [
      { value: 1, text: 'E-MAIL' },
      { value: 2, text: 'SMS' },
      { value: 3, text: 'WHATSAPP' }
    ],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/campaign/components/socialmedia/components/search/search-form.js